// extracted by mini-css-extract-plugin
export default {"root":"styles_root__9d535","singleIcon":"styles_singleIcon__aDGrV"};